"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatsbySeo = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseSeo = require("./base-seo");

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * This component render the tags in the `<head>` for SEO on a per page basis.
 * As a bare minimum, you should add a title and description.
 *
 * @remarks
 *
 * ```tsx
 * import React from 'react';
 * import { GatsbySeo } from 'gatsby-plugin-next-seo';
 *
 * export default () => (
 *   <>
 *     <GatsbySeo title='Simple Usage Example' description='A short description goes here.' />
 *     <p>Simple Usage</p>
 *   </>
 * );
 * ```
 *
 * @public
 */
var GatsbySeo = function GatsbySeo(_ref) {
  var metaTags = _ref.metaTags,
      linkTags = _ref.linkTags,
      canonical = _ref.canonical,
      description = _ref.description,
      facebook = _ref.facebook,
      htmlAttributes = _ref.htmlAttributes,
      language = _ref.language,
      languageAlternates = _ref.languageAlternates,
      mobileAlternate = _ref.mobileAlternate,
      nofollow = _ref.nofollow,
      noindex = _ref.noindex,
      openGraph = _ref.openGraph,
      title = _ref.title,
      titleTemplate = _ref.titleTemplate,
      twitter = _ref.twitter,
      base = _ref.base;
  return /*#__PURE__*/_react["default"].createElement(_baseSeo.BaseSeo, {
    metaTags: metaTags,
    linkTags: linkTags,
    canonical: canonical,
    description: description,
    facebook: facebook,
    htmlAttributes: htmlAttributes,
    language: language,
    languageAlternates: languageAlternates,
    mobileAlternate: mobileAlternate,
    nofollow: nofollow,
    noindex: noindex,
    openGraph: openGraph,
    title: title,
    titleTemplate: titleTemplate,
    twitter: twitter,
    base: base
  });
};

exports.GatsbySeo = GatsbySeo;